export const phoneNumberPattern =
  /^\++[9]+[9]+[8]+[' ']+[3,8,7,9]+[0-1,3-5,7-9]+[' ']+[0-9]+[0-9]+[0-9]+[' ']+[0-9]+[0-9]+[' ']+[0-9]+[0-9]+$/i;
